import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';

import {TERMS} from '../../constants/typesMessages';
import {useGetConditions} from '../../hooks/useGetConditions';
import {
  filterCommercialConditionsByProductsFromPsrsSelected,
  filterProductMulti
} from '../../services/commercialConditions';
import {useChatStore} from '../../store/slices/chatStore';
import {useParameterizationStore} from '../../store/slices/parameterizationStore';
import {usePsrStore} from '../../store/slices/psrStore';
import {useTermsStore} from '../../store/slices/termsStore';

const ModalTerms = (props) => {
  const psrsSelected = usePsrStore((state) => state.psrsSelected);
  const psrsWithProducts = usePsrStore((state) => state.psrsWithProducts);
  const openCloseModalTerms = useTermsStore(
    (state) => state.openCloseModalTerms
  );
  const commercialConditions = useTermsStore(
    (state) => state.commercialConditions
  );
  const commercialConditionsSelected = useTermsStore(
    (state) => state.commercialConditionsSelected
  );
  const setCommercialConditionsSelected = useTermsStore(
    (state) => state.setCommercialConditionsSelected
  );
  const setOpenCloseModalTerms = useTermsStore(
    (state) => state.setOpenCloseModalTerms
  );
  const segregationTerms = useParameterizationStore(
    (state) => state.segregationTerms
  );
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const [displayButton, setDisplayButton] = useState(false);

  useGetConditions();

  const showComercialConditionsByProductsFromPsrSelected = () => {
    let newGroupComercialConditions = [];

    newGroupComercialConditions =
      filterCommercialConditionsByProductsFromPsrsSelected(
        commercialConditions,
        psrsSelected,
        psrsWithProducts
      );

    newGroupComercialConditions = filterProductMulti(
      segregationTerms,
      newGroupComercialConditions
    );

    setCommercialConditionsSelected(newGroupComercialConditions);
  };

  const showTerms = () => {
    setOpenCloseModalTerms(!openCloseModalTerms);
  };

  useEffect(() => {
    if (commercialConditions && commercialConditions.length > 0) {
      showComercialConditionsByProductsFromPsrSelected();
    }
  }, [commercialConditions]);

  useEffect(() => {
    setDisplayButton(!!commercialConditionsSelected.length);
    if (commercialConditions && !commercialConditions.length) {
      responseTypeChange(TERMS.TERMS_CONDITIONS_ERROR);
    }
  }, [commercialConditionsSelected]);

  return (
    <div
      className="message-line"
      id={`buttons-options-continue-${props.question.id}`}
      data-aut-test="buttons-options-continue-chat-now-or-later"
    >
      {displayButton && (
        <div className="div-button">
          <button
            id="read-terms"
            data-aut-test="read-terms"
            data-testid="read-terms"
            type="button"
            onClick={() => showTerms()}
          >
            LER
          </button>
        </div>
      )}
    </div>
  );
};

ModalTerms.propTypes = {
  question: PropTypes.object
};

export default ModalTerms;
